import axios from "axios";
const feedbackAxios = axios.create();
let BASE_URL = process.env.REACT_APP_FEEDBACK_URL;
let headers = {
    'Accept': 'application/json',
    'Content-Type' : 'application/json',
    'x-api-key' : process.env.REACT_APP_FEEDBACK_API_KEY
}

feedbackAxios.defaults.baseURL = BASE_URL;
feedbackAxios.defaults.headers = headers;

export default feedbackAxios;
